import { PreloadedQuery } from 'react-relay';

import { createRelayResource } from '@townsquare/relay-utils';
import { RouteResource } from '@townsquare/router/routing-types';

import ProjectHeaderRefreshedQuery, {
	type ProjectHeaderRefreshedQuery as ProjectHeaderRefreshedQueryType,
} from '../components/ProjectHeaderRefreshed/__generated__/ProjectHeaderRefreshedQuery.graphql';

export const projectViewHeaderResource: RouteResource<
	PreloadedQuery<ProjectHeaderRefreshedQueryType, Record<string, unknown>>
> = createRelayResource<ProjectHeaderRefreshedQueryType>({
	getQuery: (routerContext) => {
		return {
			query: ProjectHeaderRefreshedQuery,
			variables: {
				key: routerContext.match.params.id ?? '',
				trackViewEvent: 'DIRECT',
			},
		};
	},
});
